/**
 * VueExternalModule
 * Helper to load external JS module.
 */
export default {
  methods: {
      /**
       * Use this when you need to load a JS library modifying the DOM other than Vue
       *
       * @param {Function} cb
       */
    loadExternalModule(cb) {
      this.$nextTick(() => {
        cb();
      });
    }
  }
};
